import { EntitlementSlugEnum } from '@electricjs/core_entity-client';

import { OrganizationPackageWithEntitlements } from '@/types/packages';

/**
 * Helper function to check if a specific organization package has an entitlement slug.
 */
export const getOrganizationPackageHasEntitlement = (
  organizationPackages: OrganizationPackageWithEntitlements[] | undefined,
  organizationPackageId: string,
  slug: EntitlementSlugEnum
): boolean | undefined => {
  if (!organizationPackages) {
    return undefined;
  }

  return organizationPackages.some(
    orgPkg =>
      orgPkg.id === organizationPackageId &&
      orgPkg.package.entitlements.some(entitlement => entitlement.slug === slug)
  );
};
